import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import { Form, Input } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const PasswordInput = ({ disabled = false, required }) => {
  const rules = [RULES.PASSWORD_STRENGTH, RULES.PASSWORD_LENGTH]
  if (required) {
    rules.push(RULES.REQUIRED)
  }

  return (
    <>
      <span>{FIELD_LABEL.PASSWORD}</span>
      <Form.Item
        name={FIELD_NAME.PASSWORD}
        rules={rules}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Input.Password
          className={styles.form_input}
          disabled={disabled}
          placeholder={'Password'}
        />
      </Form.Item>
    </>
  )
}

PasswordInput.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool
}

export default PasswordInput
